import {CRISES} from '../content/crises';
import {zgShock} from './zeitgeist';
import {OUTLETS} from '../content/parties';
import {DI,on} from '../content/settings';
import {blocker} from './budget';
import {applyEff} from './economy';
import {toast} from './govern';
import {press} from './media';
import {choice,rnd} from './rng';
import {PN,score} from './rules';
import {S,log} from './state';
import {clamp} from './util';
import {since} from './version';
import {strikeChance} from './fair';


export function crisisTick(){
  if(!on('crisis')||S.crisis||blocker())return false;
  // Version 8: Große soziale Schere macht Großstreiks wahrscheinlicher
  if(since(8)&&strikeChance()>0&&!(S.crisisHist||[]).slice(-3).includes('streik')&&rnd()<strikeChance()){const c=CRISES.find((x:any)=>x.id==='streik');if(c){
    S.crisis={id:c.id,m:S.m};(S.crisisHist=S.crisisHist||[]).push(c.id);if(since(10))(S.crisisLog??=[]).push({id:c.id,m:S.m,leg:S.leg});zgShock(c.id);
    log(`Krise: ${c.t}. ${c.s} Hintergrund ist die wachsende Kluft zwischen Arm und Reich.`,'bad');toast(`Krise: ${c.t}`,'bad');press(OUTLETS[0].n,`${c.t}: ${c.s.split('.')[0]}`,-.6);return true}}
  if(rnd()<[.015,.03,.05][DI()]){
    const recent=S.crisisHist||[],pool=CRISES.filter((c:any)=>!recent.slice(-3).includes(c.id));const c=choice(pool);
    S.crisis={id:c.id,m:S.m};(S.crisisHist=recent).push(c.id);if(since(10))(S.crisisLog??=[]).push({id:c.id,m:S.m,leg:S.leg});zgShock(c.id);
    log(`Krise: ${c.t}. ${c.s}`,'bad');toast(`Krise: ${c.t}`,'bad');press(OUTLETS[0].n,`${c.t}: ${c.s.split('.')[0]}`,-.6);return true}
  return false;
}
export function decideCrisis(i?:any){
  const C=CRISES.find((c:any)=>c.id===S.crisis!.id),o=C.o[i];S.crisis=null;
  const e:any={...o.e};if(e.debt)e.debt=e.debt*(DI()===2?1.15:1);
  applyEff(e);
  S.partners.forEach((p:any)=>{const s=score(p,o.pos);if(Object.keys(o.pos).length){const d=(s-.55)*14;S.coal=clamp(S.coal+d,0,100);if(d<-3)log(`${PN(p)} kritisiert eure Krisenentscheidung scharf.`,'bad')}});
  if(Object.keys(o.pos).length)S.basis+=(score('YOU',o.pos)-.55)*2;
  if(o.press)press(OUTLETS[0].n,o.press[0],o.press[1]);else press(OUTLETS[1].n,`${C.t}: Regierung entscheidet sich für „${o.l}“`,0);
  log(`${C.t}: Ihr entscheidet euch für „${o.l}“.`);
}
